import React, {useCallback, useEffect, useState} from 'react'
import useApi from '../../hooks/useApi'
// import {ActionLog} from '../../types/ActionLog'
import {SpinnerLoad} from '../Loading/SpinnerLoad'

export const ActionsLog = () => {

    const api = useApi()

    // const [actions, setActions] = useState<ActionLog[]>([])
    const [load, setLoad] = useState<boolean>(false)

    const loadActions = useCallback(async () => {
        setLoad(true)
        await api.get("admin/osc/log").then(res => {
            // setActions(res.data)
        }).catch(console.log)
        setLoad(false)
    }, [api])

    useEffect(() => {
        loadActions()
    }, [loadActions])

    return (
        <>
            <div className='grid grid-cols-12 text-gray-700'>
                <div className='col-span-2 p-2 font-bold'>Data</div>
                <div className='col-span-4 p-2 font-bold'>Osc</div>
                <div className='col-span-6 p-2 font-bold'>Atividade</div>
            </div>
            {!load ?

                <div>
                    {/* {actions?.map(item => (
                        <div key={item.id} className='grid grid-cols-12 bg-white even:bg-gray-500'>
                            <div className='col-span-2 p-2 '>{item.created_at}</div>
                            <div className='col-span-4 p-2 '>{item.osc.corporate_name ?? item.osc.corporate_name}</div>
                            <div className={`col-span-6 p-2 ${item.emphasis && 'text-blue-500'}`}>
                                {item.action}
                            </div>
                        </div>
                    ))} */}
                </div>
                :
                <SpinnerLoad/>
            }

        </>
    )
}
